import React from 'react';
import CommonButton from '../CommonButton';

function MatchingActions({ isMatching, isConnected, onStart, onCancel }) {
    return (
        <div className="initial-matching-actions">
            {!isMatching && (
                <CommonButton
                    text="새로운 매칭 시작"
                    variant = "primary"
                    onClick={onStart}
                    disabled={!isConnected}
                />
            )}
            {isMatching && (
                <CommonButton
                    text="매칭 취소"
                    variant="warning"  /* 노란색/경고 버튼 */
                    onClick={onCancel}
                />
            )}
        </div>
    );
}

export default MatchingActions;